/* global G */
import settings from '@tenant/settings'

/**
 * Initializes the pin adapter by calling its `init` method.
 *
 * @param {Gaia.Web.Application|Gaia.Mobile.Application} obj the platform Application
 * @returns {function(*): Promise<*>}
 */
const init = obj => async (args) => {
  if (!!obj[G.ADAPTER][G.SESSION][G.STATE][G.META] && settings.pinCreator?.enabled) {
    const eventBus = obj[G.ADAPTER][G.EVENTS]

    await new Promise((resolve) => {
      eventBus.add(eventBus.type(G.PIN, G.DONE), () => { resolve(true) }, { once: true })
      eventBus.dispatch(eventBus.type(G.PIN, G.INIT))
    })
  }

  return args
}

export default init
